import axios from "axios";
import config from "../config";

const https = require('https');

const agent = new https.Agent({
    rejectUnauthorized: false,
});

const instance = axios.create({
    baseURL: config.WS_BASE_URL,
});

instance.interceptors.request.use(async(config) => {
    config.httpsAgent = agent
    const token = localStorage.getItem("token");
    config.headers.Authorization = token ? token : "";
    config.headers.ContentType = "application/json";
    return config;
});

export const createNewEvent = async(newEvent) =>
    await instance.post("ticket/event/create", { newEvent });

export const updateEvent = async(Event) =>
    await instance.post("ticket/event/update", { Event });

export const deleteEvent = async(eventID) =>
    await instance.post("ticket/event/delete", { eventID });

export const getAllEvents = async() =>
    await instance.post("ticket/event/all");

export const getAllEvents20 = async(page) =>
    await instance.post("ticket/event/all20",{page});
    
export const getCartEvents = async(cartEvents) =>
    await instance.post("ticket/event/cartevents",{cartEvents});

export const checkoutAPI = async(cart,clientName,clientEmail,total,totalNow,Seller,Loc,phone,notes,SellerInfo) =>
    await instance.post("ticket/event/checkout",{cart,clientName,clientEmail,total,totalNow,Seller,Loc,phone,notes,SellerInfo});

export const updateOrderNotes = async(notes, orderId) =>
    await instance.post("ticket/order/update/notes",{notes, orderId});

export const deleteOrder = async(order) =>
    await instance.post("ticket/order/delete",{order});

export const updateOrderQuantity = async(orderId, updatesArray) =>
    await instance.post("ticket/order/update",{orderId, updatesArray});

export const getOrder = async(orderID) =>
    await instance.post("ticket/event/order",{orderID});

export const finalPay = async(orderID,total) =>
    await instance.post("ticket/event/pay",{orderID,total});

export const calcSeller = async(id) =>
    await instance.post("ticket/event/calcseller",{id});

export const receiveDeposit = async(id) =>
    await instance.post("ticket/event/receivedeposit",{id});
    
export const getDepositLogs = async() =>
    await instance.post("ticket/event/deposit/log");

export const report = async(date,eDate,sellerID) =>
    await instance.post("ticket/event/report",{date,eDate,sellerID});

export const events20 = async() =>
    await instance.post("ticket/event/report/20events");
    
export const salesByProd = async(prodID) =>
    await instance.post("ticket/event/report/salesbyprod",{prodID});

export const salesByProdBySeller = async(prodID) =>
    await instance.post("ticket/event/report/salesbyprodbyseller",{prodID});

export const eventByDate = async(date) =>
    await instance.post("ticket/event/bydate",{date}); 

export const reportByEvent = async(eventID,sellerID,date) =>
    await instance.post("ticket/event/reportbyevent",{eventID,sellerID,date});    
    
export const vipTables = async(date) =>
    await instance.post("ticket/event/report/vip",{date}); 

export const vipTablesOnline = async(date) =>
    await instance.post("ticket/event/report/viponline",{date}); 

export const vipTablesOnlinePool = async(date) =>
    await instance.post("ticket/event/report/viponlinepool",{date}); 

export const depositList = async(sellerID) =>
    await instance.post("ticket/event/report/depositlist",{sellerID}); 

export const totalDepositList = async() =>
    await instance.post("ticket/event/report/totaldepositlist"); 

export const selfSales = async(sellerID) =>
    await instance.post("ticket/event/report/selfsales",{sellerID}); 

export const selfSalesAll = async(sellerID) =>
    await instance.post("ticket/event/report/selfsales/all",{sellerID}); 

export const selfSalesPaid = async(sellerID) =>
    await instance.post("ticket/event/report/selfsales/paid",{sellerID}); 

export const getTopSeller = async() =>
    await instance.post("ticket/event/report/topseller"); 
    
export const getWooStock = async(eventID) =>
    await instance.post("ticket/event/report/woostock",{eventID});
    
export const getOrdersNotCollected = async() =>
    await instance.post("ticket/event/report/editorders"); 

export const markCollected = async(orderID) =>
    await instance.post("ticket/event/report/editorders/collected",{orderID});

export const allTimeSalesBySeller = async() =>
    await instance.post("ticket/event/report/alltimesales/byseller");

export const getMapLoc = async(date) =>
    await instance.post("ticket/event/report/stats/map",{date});

export const sendVenueHire = async(name,email,phone,eventDate,people,venue,desc) =>
    await instance.post("ticket/event/venue/hire",{name,email,phone,eventDate,people,venue,desc});

export const reportByDate = async(date,eDate) =>
    await instance.post("ticket/event/report/bydate",{date,eDate});

export const reportTodayTicketsBySeller = async() =>
    await instance.post("ticket/event/report/today/tickets/byseller");

export const sellersList = async() =>
    await instance.post("ticket/sellers/list",{});

export const resellersList = async() =>
    await instance.post("ticket/resellers/list",{});

export const allSellersList = async() =>
    await instance.post("ticket/sellers/list/all",{});

export const sellersCategories = async() =>
    await instance.post("ticket/sellers/categories",{});

export const updatePermissions = async(sellerId,active,sellerCategories,limit) =>
    await instance.post("ticket/sellers/update/permissions",{sellerId,active,sellerCategories,limit});

export const notSellers = async() =>
    await instance.post("ticket/notsellers/list",{});

export const newSeller = async(id) =>
    await instance.post("ticket/sellers/new",{id});

export const updateSellerCats = async(id) =>
    await instance.post("ticket/sellers/update/allowed/cats",{id});

export const getLastOrder = async(sellerId) =>
    await instance.post("ticket/sellers/last/order",{sellerId});

export const updateOrder = async(orderId,clientName,clientPhone) =>
    await instance.post("ticket/sellers/last/order/update",{orderId,clientName,clientPhone});

export const fetchNiceReport = async(date,eDate) =>
    await instance.post("ticket/event/report/alltimesales/byseller",{date,eDate}); 

export const killAllSellers = async(state) =>
    await instance.post("ticket/sellers/kill",{state});

export const sendReminder = async(prodId,dateString) =>
    await instance.post("ticket/event/reminder",{prodId,dateString});

export const updateColor = async(prodId,color) =>
    await instance.post("ticket/event/color",{prodId,color});

export const getMoneyOwedNext3Events = async(sellerID) =>
    await instance.post("ticket/event/report/next3",{sellerID});

export const getMoneyOwedNext3EventsAllResellers = async() =>
    await instance.post("ticket/event/report/next3/all",{});

export const markOrdersPaid = async(eventId,sellerName) =>
    await instance.post("order/mark/paid",{eventId,sellerName});